export class Address {

    // Properties
	$id: number;
	AddressId: number;
	ApartmentNumber: number | string;
	ApartmentNumberLastChange: number | string;
	ApartmentNumberNew: number | string;
	City: string;
	CityLastChange: string;
	CityNew: string;
	Country: string;
	CountryLastChange: string;
	CountryNew: string;
	Direction: string;
	DirectionLastChange: string;
	DirectionNew: string;
	GroupIdentifier: string;
	HomePhone1: string;
	HomePhone1LastChange: string;
	HomePhone1New: string;
	HomePhone2: string;
	HomePhone2LastChange: string;
	HomePhone2New: string;
	HouseNumber: number | string;
	HouseNumberLastChange: number | string;
	HouseNumberNew: number | string;
	Id: number;
	LanguageAtHome: string;
	LanguageAtHomeLastChange: string;
	LanguageAtHomeNew: string;
	Phone: string;
	PhoneNew: string;
	POBox: string;
	POBoxAddressCity: string;
	POBoxAddressCityLastChange: string;
	POBoxAddressCityNew: string;
	POBoxAddressLine1: string;
	POBoxAddressLine1LastChange: string;
	POBoxAddressLine1New: string;
	POBoxAddressLine2: string;
	POBoxAddressLine2LastChange: string;
	POBoxAddressLine2New: string;
	POBoxAddressLine3: string;
	POBoxAddressLine3LastChange: string;
	POBoxAddressLine3New: string;
	POBoxAddressState: string;
	POBoxAddressStateLastChange: string;
	POBoxAddressStateNew: string;
	POBoxAddressZip: number | string;
	POBoxAddressZipLastChange: number | string;
	POBoxAddressZipNew: number | string;
	POBoxLastChange: string;
	POBoxNew: string;
	PrimaryAddress: boolean;
	SameAsPrimaryResidence: boolean;
	SameAsPrimaryResidenceOld: boolean;
	SendMailingsInSpanish: boolean;
	SendMailingsInSpanishLastChange: boolean;
	SendMailingsInSpanishNew: boolean;
	State: string;
	StateLastChange: string;
	StateNew: string;
	StreetName: string;
	StreetNameLastChange: string;
	StreetNameNew: string;
	StreetType: string;
	StreetTypeLastChange: string;
	StreetTypeNew: string;
	SyncAddress: boolean;
	ZipCode: string;
	ZipCode2: string;
	ZipCode2LastChange: string;
	ZipCode2New: string;
	ZipCodeLastChange: string;
    ZipCodeNew: string;

    // Methods
    isMatching(other: Address): boolean {
        // PRE: ab address to match this with
        // POST: tells you whether they are matching (NOT EQUAL!!!)
        return this.POBoxLastChange == other.POBoxLastChange &&
            this.HouseNumberLastChange == other.HouseNumberLastChange &&
            this.DirectionLastChange == other.DirectionLastChange &&
            this.StreetNameLastChange == other.StreetNameLastChange &&
            this.StreetTypeLastChange == other.StreetTypeLastChange &&
            this.ApartmentNumberLastChange == other.ApartmentNumberLastChange &&
            this.CityLastChange == other.CityLastChange &&
            this.StateLastChange == other.StateLastChange &&
            this.ZipCodeLastChange == other.ZipCodeLastChange &&
            this.ZipCode2LastChange == other.ZipCode2LastChange &&
            this.CountryLastChange == other.CountryLastChange &&
            this.POBoxNew == other.POBoxNew &&
            this.HouseNumberNew == other.HouseNumberNew &&
            this.DirectionNew == other.DirectionNew &&
            this.StreetNameNew == other.StreetNameNew &&
            this.StreetTypeNew == other.StreetTypeNew &&
            this.ApartmentNumberNew == other.ApartmentNumberNew &&
            this.CityNew == other.CityNew &&
            this.StateNew == other.StateNew &&
            this.ZipCodeNew == other.ZipCodeNew &&
            this.ZipCode2New == other.ZipCode2New &&
            this.CountryNew == other.CountryNew &&
			this.PhoneNew == other.PhoneNew;
    }

    changed(): boolean {
        // POST: returns true if the address has changed
        return !(this.POBox == this.POBoxNew &&
            this.HouseNumber == this.HouseNumberNew &&
            this.Direction == this.DirectionNew &&
            this.StreetName == this.StreetNameNew &&
            this.StreetType == this.StreetTypeNew &&
            this.ApartmentNumber == this.ApartmentNumberNew &&
            this.City == this.CityNew &&
            this.State == this.StateNew &&
            this.ZipCode == this.ZipCodeNew &&
            this.ZipCode2 == this.ZipCode2New &&
            this.Country == this.CountryNew &&
			this.Phone == this.PhoneNew);
    }

	clear() {
		// PRE: an address to clear
		// POST: clears out the address' variables
		this.POBoxNew = '';
		this.HouseNumberNew = '';
		this.DirectionNew = '';
		this.StreetNameNew = '';
		this.StreetTypeNew = '';
		this.ApartmentNumberNew = '';
		this.CityNew = '';
		this.StateNew = '';
		this.ZipCodeNew = '';
		this.ZipCode2New = '';
		this.CountryNew = '';
		this.HomePhone1New = '';
		this.HomePhone2New = '';
		this.LanguageAtHomeNew = '0';
		this.POBoxAddressLine1New = '';
		this.POBoxAddressLine2New = '';
		this.POBoxAddressLine3New = '';
		this.POBoxAddressCityNew = '';
		this.POBoxAddressStateNew = '';
		this.POBoxAddressZipNew = '';
		this.PhoneNew = '';
	}

	setEqual(address: Address) {
		// PRE: an address to set this equal to
		// POST: sets the first address to the second address
		// NOTE: we're not using Object.assign because not every field is copied
		this.POBoxNew = address.POBoxNew;
		this.HouseNumberNew = address.HouseNumberNew;
		this.DirectionNew = address.DirectionNew;
		this.StreetNameNew = address.StreetNameNew;
		this.StreetTypeNew = address.StreetTypeNew;
		this.ApartmentNumberNew = address.ApartmentNumberNew;
		this.CityNew = address.CityNew;
		this.StateNew = address.StateNew;
		this.ZipCodeNew = address.ZipCodeNew;
		this.ZipCode2New = address.ZipCode2New;
		this.CountryNew = address.CountryNew;
		this.HomePhone1New = address.HomePhone1New;
		this.HomePhone2New = address.HomePhone2New;
		this.LanguageAtHomeNew = address.LanguageAtHomeNew;
		this.POBoxAddressLine1New = address.POBoxAddressLine1New;
		this.POBoxAddressLine2New = address.POBoxAddressLine2New;
		this.POBoxAddressLine3New = address.POBoxAddressLine3New;
		this.POBoxAddressCityNew = address.POBoxAddressCityNew;
		this.POBoxAddressStateNew = address.POBoxAddressStateNew;
		this.POBoxAddressZipNew = address.POBoxAddressZipNew;
		this.PhoneNew = address.PhoneNew;
	}

	setAsBasis(address: Address) {
		// PRE: an address to set as the basis
		// POST: sets this address to that address
		// NOTE: cannot use object.assign as not every value is set
		this.setEqual(address);
		this.POBox = address.POBox;
		this.HouseNumber = address.HouseNumber;
		this.Direction = address.Direction;
		this.StreetName = address.StreetName;
		this.StreetType = address.StreetType;
		this.ApartmentNumber = address.ApartmentNumber;
		this.City = address.City;
		this.State = address.State;
		this.ZipCode = address.ZipCode;
		this.ZipCode2 = address.ZipCode2;
		this.Country = address.Country;
		this.HomePhone1 = address.HomePhone1;
		this.HomePhone2 = address.HomePhone2;
		this.LanguageAtHome = address.LanguageAtHome;
		this.POBoxAddressLine1 = address.POBoxAddressLine1;
		this.POBoxAddressLine2 = address.POBoxAddressLine2;
		this.POBoxAddressLine3 = address.POBoxAddressLine3;
		this.POBoxAddressCity = address.POBoxAddressCity;
		this.POBoxAddressState = address.POBoxAddressState;
		this.POBoxAddressZip = address.POBoxAddressZip;
		this.Phone = address.Phone;
	}

	setAsLastChange(address: Address) {
		// PRE: an address to set as this address' last change
		// POST: sets this addresses last change to the values of address2
		// NOTE: we're not using Object.assign because not every field is copied
		this.POBoxLastChange = address.POBoxNew;
		this.HouseNumberLastChange = address.HouseNumberNew;
		this.DirectionLastChange = address.DirectionNew;
		this.StreetNameLastChange = address.StreetNameNew;
		this.StreetTypeLastChange = address.StreetTypeNew;
		this.ApartmentNumberLastChange = address.ApartmentNumberNew;
		this.CityLastChange = address.CityNew;
		this.StateLastChange = address.StateNew;
		this.ZipCodeLastChange = address.ZipCodeNew;
		this.ZipCode2LastChange = address.ZipCode2New;
		this.CountryLastChange = address.CountryNew;
		this.HomePhone1LastChange = address.HomePhone1New;
		this.HomePhone2LastChange = address.HomePhone2New;
		this.LanguageAtHomeLastChange = address.LanguageAtHomeNew;
		this.POBoxAddressLine1LastChange = address.POBoxAddressLine1New;
		this.POBoxAddressLine2LastChange = address.POBoxAddressLine2New;
		this.POBoxAddressLine3LastChange = address.POBoxAddressLine3New;
		this.POBoxAddressCityLastChange = address.POBoxAddressCityNew;
		this.POBoxAddressStateLastChange = address.POBoxAddressStateNew;
		this.POBoxAddressZipLastChange = address.POBoxAddressZipNew;
	}

	reset() {
		// PRE: an address that has its values set
		// POST: resets the address to its initial values
		this.POBoxNew = this.POBox;
		this.HouseNumberNew = this.HouseNumber;
		this.DirectionNew = this.Direction;
		this.StreetNameNew = this.StreetName;
		this.StreetTypeNew = this.StreetType;
		this.ApartmentNumberNew = this.ApartmentNumber;
		this.CityNew = this.City;
		this.StateNew = this.State;
		this.ZipCodeNew = this.ZipCode;
		this.ZipCode2New = this.ZipCode2;
		this.CountryNew = this.Country;
		this.HomePhone1New = this.HomePhone1;
		this.HomePhone2New = this.HomePhone2;
		this.LanguageAtHomeNew = this.LanguageAtHome;
		this.POBoxAddressLine1New = this.POBoxAddressLine1;
		this.POBoxAddressLine2New = this.POBoxAddressLine2;
		this.POBoxAddressLine3New = this.POBoxAddressLine3;
		this.POBoxAddressCityNew = this.POBoxAddressCity;
		this.POBoxAddressStateNew = this.POBoxAddressState;
		this.POBoxAddressZipNew = this.POBoxAddressZip;
		this.POBoxLastChange = this.POBox;
		this.HouseNumberLastChange = this.HouseNumber;
		this.DirectionLastChange = this.Direction;
		this.StreetNameLastChange = this.StreetName;
		this.StreetTypeLastChange = this.StreetType;
		this.ApartmentNumberLastChange = this.ApartmentNumber;
		this.CityLastChange = this.City;
		this.StateLastChange = this.State;
		this.ZipCodeLastChange = this.ZipCode;
		this.ZipCode2LastChange = this.ZipCode2;
		this.CountryLastChange = this.Country;
		this.HomePhone1LastChange = this.HomePhone1;
		this.HomePhone2LastChange = this.HomePhone2;
		this.LanguageAtHomeLastChange = this.LanguageAtHome;
		this.POBoxAddressLine1LastChange = this.POBoxAddressLine1;
		this.POBoxAddressLine2LastChange = this.POBoxAddressLine2;
		this.POBoxAddressLine3LastChange = this.POBoxAddressLine3;
		this.POBoxAddressCityLastChange = this.POBoxAddressCity;
		this.POBoxAddressStateLastChange = this.POBoxAddressState;
		this.POBoxAddressZipLastChange = this.POBoxAddressZip;
		this.PhoneNew = this.Phone;
	}
}
